import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import type { Contact } from 'entities/Contacts/model/Contact'
import type { SurveySendStore } from 'widgets/SurveySend/store/SurveySendStore'

type ISurveySendButtonProps = {
  store: SurveySendStore
  contact?: Contact
}

export const SurveySendButton: FC<ISurveySendButtonProps> = observer(({ store, contact }) => {
  const blockReason =
    contact && contact.id > 0 ? store.getBlockReason(contact) : store.getBlockReason()

  return (
    <Button
      size='medium'
      aria-label={'SurveySendButton'}
      iconProps={{ icon: 'clipboardCheck' }}
      text={store.label}
      fullWidth
      loading={!store.isChecked}
      disabled={!store.isChecked || !!blockReason}
      tooltipProps={{
        label: blockReason,
        placement: 'top',
        fullWidth: true,
        withoutPointer: true,
      }}
      onClick={() => contact && store.enrollContacts([contact.id])}
    />
  )
})
